export enum LogSeverityLevel {
		Verbose = 0,
        Information = 1,
        Warning = 2,
        Error = 3,
        Critical = 4
}